<template>
  <div>
    <!--EXAMES-->
    <ed-modal
      :modal="showModal"
      :title="
        'EXAMES' +
        (funcionario ? ' :: ' + funcionario.nome : '') +
        ' :: ' +
        formData.periodo[0] +
        ' a ' +
        formData.periodo[1]
      "
      width="97%"
    >
      <div slot="modal-content">
        <el-tabs type="border-card" v-model="tabExame">
          <el-tab-pane label="Credenciadas" name="tab-exames">
            <span slot="label"><i class="fa fa-user-md"></i> Exames</span>

            <table>
              <tr>
                <td>
                  <div
                    style="
                      width: 50px;
                      height: 10px;
                      background: #4ac467;
                      float: left;
                    "
                  >
                    &nbsp;&nbsp;&nbsp;
                  </div>
                </td>
                <td style="font-size: 9pt">
                  Dentro do Período Selecionado
                  <b>{{ formData.periodo[0] }} a {{ formData.periodo[1] }}</b
                  ><br />
                </td>
              </tr>
              <tr>
                <td>
                  <div
                    style="
                      width: 50px;
                      height: 10px;
                      background: #dd4040;
                      float: left;
                    "
                  >
                    &nbsp;&nbsp;&nbsp;
                  </div>
                </td>
                <td style="font-size: 9pt">
                  Fora do Período Selecionado
                  <b>{{ formData.periodo[0] }} a {{ formData.periodo[1] }}</b
                  ><br />
                </td>
              </tr>
              <tr>
                <td>
                  <div
                    style="
                      width: 50px;
                      height: 10px;
                      background: #d8a027;
                      float: left;
                    "
                  >
                    &nbsp;&nbsp;&nbsp;
                  </div>
                </td>
                <td style="font-size: 9pt">
                  Exame não Realizado - Fora dos requisitos do PCMSO<br />
                </td>
              </tr>
            </table>

            <ed-table
              class="mt-2"
              :tableData="tableDataExame"
              :tableHead="tableHeadExame"
              :tableFooter="tableFooterExame"
              disableInputSearch
              disableCheckAll
              disabledConfigCell
            />
          </el-tab-pane>

          <el-tab-pane
            label="Credenciadas"
            name="tab-historico"
            v-if="funcionario && formData.id_empresa"
          >
            <span slot="label"
              ><i class="fa fa-clock-o"></i> Histórico de Consultas</span
            >
            <ConsultaHistorico
              :funcionario="funcionario"
              :empresa="{ id: formData.id_empresa }"
            />
          </el-tab-pane>

          <el-tab-pane
            label="Credenciadas"
            name="tab-pcmso"
            v-if="funcionario && formData.id_empresa"
          >
            <span slot="label"
              ><i class="fa fa-user-md"></i> Exames no PCMSO</span
            >
            <Pcmso :id_ghe="funcionario.id_ghe" />
          </el-tab-pane>
        </el-tabs>
      </div>
    </ed-modal>

    <div class="col-12 text-left">
      <ed-form :data="formData" :config="config" :itens="formDataItems">
        <div slot="form-footer">
          <div class="col-md-12 btn-login">
            <ed-button
              icon="fa fa-search"
              type="success"
              @click="getPeriodico"
              :loading="config.loading.save"
              value="Pesquisar"
            />
          </div>

          <ed-alert
            v-if="!formData.id_empresa"
            class="mt-2 text-left"
            type="warning"
            title="Atenção"
            description="Selecione todos os campos obrigatórios."
          />
        </div>
      </ed-form>
    </div>

    <div class="col-12">
      <el-tabs
        type="border-card"
        v-model="tabPeriodico"
        v-if="formData.id_empresa"
      >
        <el-tab-pane label="Credenciadas" name="tab-ok">
          <span slot="label" style="color: #4ac467"
            ><i class="fa fa-thumbs-o-up"></i> Dentro do Período Selecionado ({{
              tableData.length
            }})</span
          >

          <ed-alert
            class="mb-2"
            type="success"
            description="Os trabalhadores mostrados abaixo estão com a data dos exames DENTRO PERÍODO SELECIONADO."
            title="Atenção"
          />

          <ed-table
            :tableData="tableData"
            :tableHead="tableHead"
            :pagination="pagination"
            :response="response"
            :loadingTable="loadingTable"
            :loadingEditAll="loadingTable"
            :onEditAll="onConsultaLote"
            editAllIcon="fa fa-address-card"
            editAllName="Gerar Consulta"
            editAllTitle="Gerar Consulta para os trabalhadores selecionados"
            disableInputSearch
          >
            <div slot="table-export">
              <ed-button
                icon="fa fa-download"
                type="text"
                value="Exportar Resultado para Excel"
                title="Clique aqui para exportar os dados para excel"
                @click="onExcel"
              />
            </div>
          </ed-table>
        </el-tab-pane>

        <el-tab-pane
          label="Orçamento Aproximado"
          name="tab-preco"
          v-if="formData.id_empresa && tableDataTabelaPreco.length > 0"
        >
          <span slot="label" style="color: #4ac467"
            ><i class="fa fa-usd"></i> Orçamento Aproximado</span
          >

          <ed-alert
            class="mb-2"
            type="warning"
            description="Orçamento aproximado para os periódidocos dentro do período selecionado"
            title="Atenção"
          />

          <ed-table
            :tableData="tableDataTabelaPreco"
            :tableHead="tableHeadTabelaPreco"
            :loadingTable="loadingTable"
            :loadingEditAll="loadingTable"
            disableInputSearch
            disableCheckAll
            disabledConfigCell
          />
        </el-tab-pane>

        <el-tab-pane
          label="Credenciadas"
          name="tab-nok"
          v-if="formData.id_empresa && tableDataForaPeriodo.length > 0"
        >
          <span slot="label" style="color: #dd4040"
            ><i class="fa fa-exclamation-triangle faa-flash animated"></i> Fora
            do Período Selecionado ({{ tableDataForaPeriodo.length }})</span
          >

          <ed-alert
            class="mb-2"
            type="warning"
            description="Os trabalhadores mostrados abaixo estão com o periódico atrasado"
            title="Atenção"
          />

          <ed-table
            :tableData="tableDataForaPeriodo"
            :tableHead="tableHead"
            :pagination="pagination"
            :response="response"
            :loadingTable="loadingTable"
            :loadingEditAll="loadingTable"
            disableInputSearch
            disableCheckAll
          />
        </el-tab-pane>

        <el-tab-pane
          label="Credenciadas"
          name="tab-error"
          v-if="formData.id_empresa && tableDataError.length > 0"
        >
          <span slot="label" style="color: #dd4040"
            ><i class="fa fa-exclamation-triangle faa-flash animated"></i> Erro
            de Cadastro({{ tableDataError.length }})</span
          >
          <ed-alert
            class="mb-2"
            type="error"
            description="Os trabalhadores mostrados abaixo estão com erros no cadastro."
            title="Atenção"
          />
          <ed-table
            :tableData="tableDataError"
            :tableHead="tableHead"
            :pagination="pagination"
            :response="response"
            :loadingTable="loadingTable"
            :loadingEditAll="loadingTable"
            disableInputSearch
            disabledConfigCell
            disableCheckAll
          />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import Rest from "common/rest";
import EdForm from "common/form";
import EdButton from "common/button";
import EdAlert from "common/alert";
import EdModal from "common/modal";
import EdTable from "common/table";
import ItemsFormEditar from "./_form/periodico-pesquisar";
import ConsultaHistorico from "appsWeb/consulta/_includes/historico";
import Pcmso from "appsWeb/consulta/_includes/pcmso";

export default {
  components: {
    EdTable,
    EdForm,
    EdButton,
    EdModal,
    EdAlert,
    ConsultaHistorico,
    Pcmso,
  },
  mixins: [Rest],
  watch: {
    "formData.id_empresa"() {
      this.config.disabled.id_funcionario = this.formData.id_empresa
        ? false
        : true;
      this.config.disabled.id_fdt = this.formData.id_empresa ? false : true;

      this.formData.id_funcionario = [];
      this.formData.id_fdt = [];

      this.getFdt();
      this.getFuncionario();
      this.getPeriodico();
    },
    "formData.periodo"() {
      this.config.disabled.id_empresa =
        this.formData.periodo.length == 2 ? false : true;
    },
  },
  data() {
    return {
      loadingTable: false,
      pagination: {},
      response: {},
      formDataItems: [],
      config: {
        estado: true,
        click: {
          id_empresa: this.getEmpresa,
          id_funcionario: this.getFuncionario,
          id_fdt: this.getFdt,
        },
        list: {
          id_empresa: [],
          id_funcionario: [],
          id_fdt: [],
        },
        loading: {
          id_empresa: false,
          id_funcionario: false,
          id_fdt: false,
        },
        disabled: {
          id_empresa: true,
          id_funcionario: true,
          id_fdt: true,
        },
      },
      formData: {
        id_empresa: null,
        id_fdt: [],
        id_funcionario: [],
        periodo: [],
      },
      formDataConsulta: {
        funcionario: [],
      },
      tabPeriodico: "tab-ok",
      tabExame: "tab-exames",
      tableData: [],
      tableDataForaPeriodo: [],
      tableDataError: [],
      tableDataExame: [],
      tableFooterExame: [],
      tableDataTabelaPreco: [],
      tableHeadTabelaPreco: [
        {
          key: "exame",
          sortable: true,
          label: "Exame",
        },
        {
          key: "quantidade",
          sortable: true,
          label: "Quantidade",
        },
        {
          key: "valor_venda",
          sortable: true,
          label: "Valor Unitário (R$)",
        },
        {
          key: "valor_total",
          sortable: true,
          label: "Valor Total (R$)",
        },
      ],
      tableHeadExame: [
        {
          key: "exame",
          sortable: true,
          label: "Exame",
        },
        {
          key: "valor_venda",
          sortable: true,
          label: "Valor Aproximado (R$)",
        },
        {
          key: "consulta",
          sortable: true,
          width: "215px",
          label: "Última Consulta Realizada",
        },
        {
          key: "tipo",
          sortable: true,
          label: "Tipo",
        },
        {
          key: "data",
          sortable: true,
          width: "215px",
          label: "Data Ideal Para Refazê-lo",
        },
        {
          key: "obs",
          sortable: true,
          label: "Observações",
        },
      ],
      tableHead: [
        {
          key: "nome",
          sortable: true,
          show_funcionario_link: true,
          show_funcao: true,
          label: "Nome",
        },
        {
          key: "fdt",
          sortable: true,
          label: "Frente de Trabalho",
        },
        {
          key: "ghe",
          sortable: true,
          label: "GHE (Setor)",
        },
        {
          key: "dt_per_rea",
          sortable: true,
          label: "DATA SUGERIDA PARA O PERIÓDICO",
        },
        {
          key: "obs",
          sortable: true,
          show_html: true,
          label: "Observações",
        },
      ],
      funcionario: null,
      showModal: false,
      showConsultaLote: false,
    };
  },
  beforeDestroy() {
    this.tableData = [];
    this.tableDataError = [];
    this.tableDataExame = [];
    this.tableDataForaPeriodo = [];
  },
  created() {},

  mounted() {
    this.getEmpresa();
    this.formDataItems = ItemsFormEditar;
  },

  methods: {
    onConsultaLote(data) {
      if (data.id) {
        data = [data];
      }

      this.formDataConsulta.funcionario = data;
      this.showConsultaLote = !this.showConsultaLote;
    },

    onExcel() {
      this.open("periodico/excel", { filter: this.formData });
    },

    onExames(data) {
      var tableDataExame = [];
      var tableFooterExame = [];
      let valor_total = 0;
      let item = null;

      for (let i = 0; i < data.exames.length; i++) {
        item = {
          id: data.exames[i].id,
          exame: data.exames[i].nome,
          consulta: data.exames[i].id_con
            ? "Consulta " +
              data.exames[i].id_con +
              " (" +
              this.toDate(data.exames[i].dt_cad, true) +
              ")"+(data.exames[i].validade>0 ? '<br><span>Exame válido por '+data.exames[i].validade+' dias</span>': '')
            : "---",
          tipo: data.exames[i].dt_rea ? data.exames[i].tipo : "---",
          data: data.exames[i].dt_rea
            ? this.toDate(data.exames[i].dt_rea, true)
            : "---",
          obs: data.exames[i].obs ? data.exames[i].obs : "---",
          valor_venda: data.exames[i].tabela_preco
            ? this.floatToMoney(data.exames[i].tabela_preco.valor_venda)
            : "---",
          _data: data.exames[i],
          options: {
            style: "color:" + data.exames[i].cor,
          },
          buttons: [
            {
              color: "success",
              icon: "fa fa-user-md",
              title: "Visualizar Exames",
              click: this.onExames,
            },
          ],
        };
        tableDataExame.push(item);

        if (data.exames[i].tabela_preco) {
          valor_total += Number(data.exames[i].tabela_preco.valor_venda);
        }
      }

      //VALOR TOTAL
      item = {
        id: 0,
        exame: "TOTAL",
        consulta: "---",
        tipo: "---",
        data: "---",
        obs: "---",
        valor_venda: this.floatToMoney(valor_total),
        _data: {},
        options: {
          style: "color:#000;font-weight:bold",
        },
        buttons: [],
      };
      tableDataExame.push(item);

      this.tabExame = "tab-exames";
      this.showModal = !this.showModal;
      this.tableDataExame = tableDataExame;
      this.tableFooterExame = tableFooterExame;
      this.funcionario = data;
    },

    getEmpresa(_search) {
      this.config.loading.id_empresa = true;
      this.config.list.id_empresa = [];

      this.get("empresa", { search: _search }).then((result) => {
        result = result[0];

        this.config.loading.id_empresa = false;

        if (result.status == 200) {
          this.config.list.id_empresa = result.data.data;
        }
      });
    },

    getFdt(search) {
      if (!this.formData.id_empresa) return;

      this.config.loading.id_fdt = true;
      this.config.list.id_fdt = [];

      this.get("/pcmso/fdt/" + this.formData.id_empresa, {
        search: search,
      }).then((result) => {
        result = result[0];

        this.config.loading.id_fdt = false;

        if (result.status == 200) {
          this.config.list.id_fdt = result.data.data;
        }
      });
    },

    getFuncionario(_search) {
      if (!this.formData.id_empresa) return;

      this.config.loading.id_funcionario = true;
      this.config.list.id_funcionario = [];

      this.get("empresa/funcionario/" + this.formData.id_empresa, {
        search: _search,
        pagination: 100,
      }).then((result) => {
        result = result[0];

        this.config.loading.id_funcionario = false;

        if (result.status == 200) {
          this.config.list.id_funcionario = result.data.data;
        }
      });
    },

    getPeriodico(search, page, pagination) {
      if (!this.formData.id_empresa) return;

      this.loadingTable = true;
      this.tabPeriodico = "tab-ok";

      if (this.formData.periodo.length != 2) {
        var hoje = this.toDate(null, true),
          ontem = this.toDate(this.addDate(-30, null, "D"), true),
          amanha = this.toDate(this.addDate(30, null, "D"), true);

        this.formData.periodo = [ontem, amanha];
      }

      this.get("periodico", {
        search: search,
        page: page,
        pagination: pagination,
        filter: this.formData,
      }).then((result) => {
        result = result[0];

        this.loadingTable = false;
        this.response = result;

        var data = [],
          tableData = [],
          tableDataForaPeriodo = [],
          tableDataTabelaPreco = [],
          tableDataError = [],
          pagination = {};
          
        if (result.status == 200) {
          //TABELA DE PRECO FRENTE
          result.data.per_tabela_preco.forEach((tabela_preco, index) => {

            //FDT
            var item = {
              id: index,
              exame: tabela_preco.fdt.nome,
              valor_venda: '---',
              valor_total: '---',
              quantidade: (tabela_preco.fdt.quantidade),
              _data: tabela_preco,
              options:{
                style: "color:red;font-weight:bold"
              },
              buttons: [],
            };
            tableDataTabelaPreco.push(item);

            //EXAMES
            tabela_preco.exames.forEach((tabela_preco_exame, indexExame) => {
              var item = {
              id: index+indexExame,
              exame: tabela_preco_exame.nome,
              valor_venda: (tabela_preco_exame.quantidade == 0 ? '---' : this.floatToMoney(tabela_preco_exame.valor_venda)),
              valor_total: this.floatToMoney((Number(tabela_preco_exame.valor_venda)*Number(tabela_preco_exame.quantidade))),
              quantidade: (tabela_preco_exame.quantidade),
              _data: tabela_preco_exame,
              buttons: [],
            };
            tableDataTabelaPreco.push(item);
            });
          });

          //DENTRO PERIODO
          data = result.data.per_dentro_periodo;
          for (var i = 0; i < data.length; i++) {
            var item = {
              id: data[i].id,
              nome: data[i].nome,
              cpf: data[i].cpf,
              obs: data[i].obs ? data[i].obs : "---",
              funcao: data[i].funcao ? data[i].funcao.nome : null,
              fdt: data[i].fdt
                ? data[i].fdt.pcmso + " (" + data[i].fdt.descricao + ")"
                : "---",
              ghe:
                data[i].ghe && data[i].ghe.ghe
                  ? data[i].ghe.ghe + " (" + data[i].ghe.descricao + ")"
                  : "---",
              dt_per_rea: data[i].dt_per_rea
                ? this.toDate(data[i].dt_per_rea, true) +
                  "<br>" +
                  data[i].tipo_ultima_consulta
                : "---",
              _data: data[i],
              buttons: [
                {
                  color: "success",
                  icon: "fa fa-user-md",
                  title:
                    "Visualizar Exames (" +
                    data[i].exames.length +
                    " no total)",
                  click: this.onExames,
                },
              ],
            };
            tableData.push(item);
          }

          //FORA DENTRO PERIODO
          data = result.data.per_fora_periodo;
          for (var i = 0; i < data.length; i++) {
            var item = {
              id: data[i].id,
              nome: data[i].nome,
              cpf: data[i].cpf,
              obs: data[i].obs ? data[i].obs : "---",
              funcao: data[i].funcao ? data[i].funcao.nome.toUpperCase() : null,
              fdt: data[i].fdt
                ? data[i].fdt.pcmso + " (" + data[i].fdt.descricao + ")"
                : "---",
              ghe:
                data[i].ghe && data[i].ghe.ghe
                  ? data[i].ghe.ghe + " (" + data[i].ghe.descricao + ")"
                  : "---",
              dt_per_rea: "---",
              _data: data[i],
              buttons: [
                {
                  color: "success",
                  icon: "fa fa-user-md",
                  title:
                    "Visualizar Exames (" +
                    data[i].exames.length +
                    " no total)",
                  click: this.onExames,
                },
              ],
            };
            tableDataForaPeriodo.push(item);
          }

          //ERRO PERIODO
          data = result.data.per_erro;
          for (var i = 0; i < data.length; i++) {
            var item = {
              id: data[i].id,
              nome: data[i].nome,
              cpf: data[i].cpf,
              obs: data[i].obs ? data[i].obs : "---",
              funcao: data[i].funcao ? data[i].funcao.nome.toUpperCase() : null,
              fdt: data[i].fdt
                ? data[i].fdt.pcmso + " (" + data[i].fdt.descricao + ")"
                : "---",
              ghe:
                data[i].ghe && data[i].ghe.ghe
                  ? data[i].ghe.ghe + " (" + data[i].ghe.descricao + ")"
                  : "---",
              dt_per_rea: "---",
              _data: data[i],
              buttons: [],
            };
            tableDataError.push(item);
          }
        }

        this.tableData = tableData;
        this.tableDataForaPeriodo = tableDataForaPeriodo;
        this.tableDataError = tableDataError;
        this.tableDataTabelaPreco = tableDataTabelaPreco;
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// index.vue?e4f3d278